export default "__VITE_ASSET__Di8UHnTi__"